import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import styled from 'styled-components/macro';
import useComment from "hooks/useComment";
import { CommentDialog } from "./CommentDialog";
import ChangeHistoryDialog from "./ChangeHistory/ChangeHIstoryDialog";
import { GET_COMMENT } from "store/key";

const SCommentBoxContainer = styled.div`
    position: relative;
`;

const CommentBox = ({ isEnableComment }) => {
    const dispatch = useDispatch();
    const {
        comment, onChangeComment,
        isShow,
        user,
        isShowChangeHistory, onOpenChangeHistory, onCloseChangeHistory,
        handleSave,
        onClose,
        questionField, 
        commentDetail,
        handleDelete,
        handleResolve,
        handleUpdate,
        changeLog,
    } = useComment();

    return (
        <SCommentBoxContainer>
            <CommentDialog
                isShow={isShow}
                isEnableComment={isEnableComment}
                maxWidth="sm"
                // messages={messages}
                comment={comment}
                user={user}
                onChangeComment={onChangeComment}
                handleSave={handleSave}
                onClose={onClose}
                onOpenChangeHistory={onOpenChangeHistory}
                questionField={questionField}
                commentDetail={commentDetail}
                handleDelete={handleDelete}
                handleResolve={handleResolve}
                handleUpdate={handleUpdate}
            />
            <ChangeHistoryDialog
                isShow={isShowChangeHistory}
                onConfirm={onCloseChangeHistory}
                dataList={changeLog}
            />
        </SCommentBoxContainer>
    );
};

export default CommentBox;

